const sendInterviewCompleted = () => {
  try {
    if (window.top) {
      window.top.postMessage({ type: "VIRTRIAGE_INTERVIEW_COMPLETED" }, "*");
    }
  } catch (error) {
    console.error(error);
  }
};

export { sendInterviewCompleted };
